/* eslint-disable max-len */
/* eslint-disable prefer-const */
/* eslint-disable no-console */
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getSharedList } from '../../actions/media_actions';
import { setMediaKitData } from '../../../redux/MediakitRedux';
import { useContext, useEffect } from 'react';
import { API } from 'aws-amplify';
import { MediaContext } from '../index';

const useGetSharedItems = (mediaState, setMediaState) =>
{
	const folderId = useParams()?.id || '';
	const dispatch = useDispatch();
	const { sharedData } = useSelector((state:any) => state?.mymediakit?.mediaKitData);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const itemsPerPage = 12;
	const { tab } = useContext(MediaContext);
	let sharePromise;

	const getSharedItemsList = async (filter = mediaState?.filter) =>
	{
		let query:any = {
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role,
			limit   : itemsPerPage,
			skip    : mediaState?.page

		};

		if ([ 1, -1 ].includes(mediaState?.sort)) query.sortByName = mediaState.sort;

		if (mediaState?.searchValue !== '')
		{
			query.search = mediaState?.searchValue;
		}
		const newArr:any = filter?.split(',');
		const updateArr:any = newArr?.length > 0 && newArr.map((item) => Number(item));
		const id = updateArr?.length > 0 && updateArr?.join('##');

		if (filter && filter !== '1,2,3,4,5') { query.mediaType = id; }

		const getSharedItemsCount = async () =>
		{
			query.count = 'true';
			try
			{
				const res = await getSharedList(query);

				if (res?.status)
				{
					setMediaState({ type: 'setCount', payload: { sharedItems: res?.count } });
				}
			}
			catch (err)
			{
				console.log('*****err');
			}
		};

		try
		{
			if (folderId && mediaState?.searchValue === '')
			{
				query.id = folderId;
			}
			mediaState?.page === 0 && (sharedData?.length === 0 || sharedData[0]?.parent !== '' || mediaState?.searchValue) && setMediaState({ type: 'updateReducer', payload: { loading: true } });

			let res = { status: true, data: [] };

			if (filter.length !== 0) // as per the QA requirement-#I4022
			{
				sharePromise = getSharedList(query);
				res = await sharePromise;
			}

			if (res?.status)
			{
				dispatch(setMediaKitData({ sharedData: mediaState?.page === 0 ? res?.data : [ ...sharedData, ...res.data ] }));

				if (mediaState?.page === 0 && res?.data?.length >= itemsPerPage)
				{
					getSharedItemsCount();
				}
				else
				{
					setMediaState({ type: 'setCount', payload: { sharedItems: res?.data?.length } });
				}
				setMediaState({ type: 'updateReducer', payload: { loading: false } });
			}
		}
		catch (err)
		{
			console.log('err---');
			// catchErr(err);
			setMediaState({ type: 'updateReducer', payload: { loading: false } });
		}
	};

	useEffect(() =>
	{
		return () =>
		{
			API.cancel(sharePromise, 'cancelled by user');
		};
	}, [ tab, mediaState?.page, mediaState?.sort, mediaState?.filter ]);

	return getSharedItemsList;
};

export default useGetSharedItems;